import React, {useState, useRef} from 'react';
import {connect} from 'react-redux';
import Layout from '~/Components/Layout/Layout';
import RegistrationCard from './RegistrationCard/RegistrationCard'
import GuestCard from './GuestCard/GuestCard'
import PersonalDetails from './PersonalDetails/PersonalDetails'
import SpecialRequirements from './SpecialRequirements/SpecialRequirements'
import HotelRooms from './HotelRooms/HotelRooms'
import EmergencyContact from './EmergencyContact/EmergencyContact'
import Documents from './Documents/Documents'
import Travel from './Travel/Travel'
import './registration.scss';
import {setActiveStepAction, setActiveGuestAction, startGuestProgress, stopGuestProgress} from "~/redux/actions/guests";
import classnames from 'classnames';
import { useHistory } from 'react-router';
import ActionPrompt from '../../Components/ActionPrompt/ActionPrompt';
import { Modal } from 'react-bootstrap';
import { invitationReady } from '~/helpers/invitation';
import Loader from "react-loader";
import {Link, Redirect} from "react-router-dom";
import TextTranslate from '../../Components/TextTranslate/TextTranslate';
import useEffectSkipFirst from '../../Hooks/useEffectSkipFirst';

const RsvpRegistration = ({guests, invitation, steps, activeStep, activeGuest, ...props}) => {

    const [confirmGuestDelete, setConfirmGuestDelete] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const mainCardRef = useRef();

    const history = useHistory();

    function focusOnForm() {
        mainCardRef.current?.scrollIntoView();
    }

    useEffectSkipFirst(() => {
        if(window.innerWidth < 768) {
            focusOnForm();
        }
    }, [activeStep])

    // If user has not confirmed attendance, redirect to /confirm
    if(Array.isArray(guests) && !guests.length) { history.push('/confirm'); }

    const handleStepChange = (step) => {
        props.dispatch(setActiveStepAction(step));
    };

    const handleClearGuest = (guest) => {

        setConfirmGuestDelete(false);
        setDeleteLoading(true);

        props.dispatch(stopGuestProgress(guest.id)).then(() => {
            let mainGuestIndex = guests.map((e) => e.main).indexOf(true);
            props.dispatch(setActiveGuestAction(mainGuestIndex));
        }).finally(() => setDeleteLoading(false));
    }

    const handleStartGuest = (guest) => {
        props.dispatch(startGuestProgress(guest.id));
    }

    if (!invitation || !guests || guests.length === 0) {
        return <></>;
    }

    if (invitation.registration_status === 'submitted') {
        return <Redirect to="/preview" />
    }

    const currentGuest = guests[activeGuest];
    const invitationFinished = invitationReady(guests);
    const mainGuest = guests.filter(guest => guest.main)[0];


    return (
        <Layout colorBg page="rsvpregistration">
            <div className="container container-registration">
                <div className="row">
                    <div className="col-lg-3 col-12">
                        <div className="registration-card">
                            <RegistrationCard/>
                            {guests.map((guest, key) => <GuestCard index={key} key={key} guest={guest} focusOnForm={focusOnForm} confirmGuestDelete={setConfirmGuestDelete}/>)}
                        </div>

                        <Link
                            className={classnames([
                                "btn mt-3 mb-lg-0 mb-3 w-100",
                                {
                                    "btn-primary": invitationFinished,
                                    "btn-secondary": !invitationFinished,
                                    disabled: !mainGuest?.progress || mainGuest?.progress?.complete !== mainGuest?.progress?.total
                                }
                            ])}
                            to="/preview"
                        ><TextTranslate name="word-review-submit" fallback="Review & Submit"/></Link>
                    </div>
                    <div ref={mainCardRef} className="col-lg-9 col-12">

                        {currentGuest && currentGuest.started && (
                            <>
                                <div className="navigation-card card shadow-sm bg-white mb-2">
                                    <div className="card-body navigation-card-body">
                                        <ul className="list-navigation flex-gap">
                                            {Object.keys(steps).map((step) => {
                                                return (
                                                    <li
                                                        key={step}
                                                        className={
                                                            classnames(["list-navigation__item",
                                                                {'selected': step == activeStep}]
                                                            )}
                                                    >
                                                        <a className="text-uppercase"
                                                           onClick={() => handleStepChange(step)}>
                                                            {steps[step].label}
                                                        </a>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                </div>

                                <div className="main-card card shadow-sm bg-white">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-12">
                                                {currentGuest.main && (
                                                    <p className="text-uppercase text-type-caption mb-0"><TextTranslate name="reg-main-guest" fallback="Main Guest"/></p>
                                                )}

                                                {!currentGuest.main && (
                                                    <p className="text-uppercase text-type-caption mb-0">
                                                        {currentGuest.first_name || <><TextTranslate name="reg-guest-number" fallback="Guest #"/> {activeGuest}</>}
                                                    </p>
                                                )}

                                                <h1 className="text-headline mb-4">{steps[activeStep].label}</h1>
                                            </div>
                                        </div>

                                        {activeStep === 'personal_details' && <PersonalDetails/>}
                                        {activeStep === 'special_requirements' && <SpecialRequirements/>}
                                        {activeStep === 'hotel_rooms' && <HotelRooms/>}
                                        {activeStep === 'travel' && <Travel/>}
                                        {activeStep === 'emergency_contact' && <EmergencyContact/>}
                                        {activeStep === 'documents' && <Documents/>}
                                    </div>
                                </div>
                            </>
                        )}

                        {currentGuest && !currentGuest.started && (
                            <div className="main-card card shadow-sm bg-white">
                                <div className="card-body">
                                    <a onClick={(e) => handleStartGuest(currentGuest)} className="btn btn-primary">
                                        <TextTranslate name="word-start-registration" fallback="Start Registration" textOnly/>
                                    </a>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            </div>

            <Modal show={confirmGuestDelete} onHide={() => setConfirmGuestDelete(false)}>
                <Modal.Header closeButton>
                    <Modal.Title><TextTranslate name="reg-delete-guest" fallback="Delete guest"/></Modal.Title>
                </Modal.Header>
                <Modal.Body><TextTranslate name="guest-delete-confirmation-msg" fallback="This will delete all information currently saved for this guest, and cannot be undone. Are you sure you want to proceed?" textOnly/></Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger btn-xs" onClick={() => handleClearGuest(currentGuest)}>
                        <TextTranslate name="guest-delete-modal-yes" fallback="Yes, Delete" textOnly/>
                    </button>
                    <button className="btn btn-secondary btn-xs" onClick={() => setConfirmGuestDelete(false)}>
                        <TextTranslate name="guest-delete-modal-no" fallback="No, Cancel" textOnly/>
                    </button>
                </Modal.Footer>
            </Modal>

            {currentGuest && !currentGuest.main && currentGuest.started && (
                <ActionPrompt classes="d-lg-block d-none prompt-delete-guest">
                    <div className="d-flex">
                        <p className="text-subhead text-danger d-sm-block d-none mb-0 mr-3"><TextTranslate name="reg-delete-guest" fallback="Delete guest"/></p>
                        <p className="text-subhead mb-0"><TextTranslate name="guest-delete-note" fallback="This will remove all information currently saved under this guest." textOnly/></p>
                    </div>
                    <a className="link text-body-size text-danger text-uppercase font-weight-500 position-relative"
                       onClick={() => setConfirmGuestDelete(true)}>
                        <Loader loaded={!deleteLoading} loadedClassName="">
                            <TextTranslate name="reg-delete-guest" fallback="Delete guest"/>
                        </Loader>
                    </a>
                </ActionPrompt>
            )}

        </Layout>
    );
}

const mapStateToProps = (state) => ({
    auth: state.auth.auth,
    invitation: state.invitation.data,
    guests: state.guests?.list,
    activeStep: state.guests?.activeStep[state.guests?.activeGuest],
    activeGuest: state.guests?.activeGuest,
    steps: state.guests?.steps,
});

export default connect(mapStateToProps)(RsvpRegistration);
